export default function MapSpinnerOverlay() {
    return (
        <div className="MapSpinnerOverlay">
            <div className="MapSpinnerOverlay-inner">
                <div className="MapSpinnerOverlay-content">
                    <span className="MapSpinnerOverlay-spinner" />
                </div>
            </div>
        </div>
    );
}
